export const GTM_ID = "GTM-M4HWNJB";

export const HOTJAR_ID = 2789605;
export const HOTJAR_SNIPPET_VERSION = 6;

// Prefixes of cookies and storage entries created by Google Analytics / Tag Manager and Hotjar
export const ANALYTICS_COOKIE_PREFIXES = [ "_ga", "_gid", "_gat", "_gcl", "_hj" ];
export const ANALYTICS_STORAGE_PREFIXES = [ "_hj" ];

// Google Analytics keeps one cookie per data stream, named after the measurement ID without its "G-" prefix
export const GA_STREAM_COOKIE_PREFIX = "_ga_";
export const GA_MEASUREMENT_ID_PREFIX = "G-";

// Setting window[ "ga-disable-<measurement ID>" ] is the opt-out switch documented by Google Analytics
export const GA_DISABLE_FLAG_PREFIX = "ga-disable-";
